var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5C0 3.18629 2.68629 0.5 6 0.5H30C33.3137 0.5 36 3.18629 36 6.5V30.5C36 33.8137 33.3137 36.5 30 36.5H6C2.68629 36.5 0 33.8137 0 30.5V6.5Z",
    fill: "#619BF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1915 18.503L15.2199 22.6613C15.0788 22.8104 15 23.0094 15 23.2165C15 23.4237 15.0788 23.6227 15.2199 23.7718C15.2891 23.844 15.3716 23.9014 15.4629 23.9406C15.5541 23.9798 15.6521 24 15.751 24C15.85 24 15.948 23.9798 16.0392 23.9406C16.1305 23.9014 16.213 23.844 16.2821 23.7718L20.7818 19.0619C20.918 18.9167 20.9958 18.7246 20.9998 18.5238C21.0038 18.3229 20.9337 18.1278 20.8034 17.9771L16.2845 13.2293C16.2156 13.1567 16.1331 13.0991 16.0418 13.0597C15.9506 13.0203 15.8525 13 15.7534 13C15.6544 13 15.5563 13.0203 15.4651 13.0597C15.3738 13.0991 15.2913 13.1567 15.2223 13.2293C15.0812 13.3784 15.0024 13.5774 15.0024 13.7845C15.0024 13.9916 15.0812 14.1907 15.2223 14.3398L19.1915 18.503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSide);
export default __webpack_public_path__ + "static/media/arrow_side.10d5c3965fdc48c2a5ea3c89ff735cac.svg";
export { ForwardRef as ReactComponent };